import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';

import type { RecruitingStatusFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<RecruitingStatusFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <FormField
      control={form.control}
      name="name"
      render={({ field }) => (
        <FormInput
          formItemClassName="col-span-12"
          label="Recruiting Status (required)"
          {...field}
          disabled={!isEditable}
          autoFocus={autoFocus}
        />
      )}
    />
  );
}
